import AseanBanner from "@routes/Section/layouts/Verticals/AseanBusiness/components/AseanBanner";
import GlobalEnterpriseBanner from "@routes/Section/layouts/Verticals/GlobalEnterprise/components/GlobalEnterpriseBanner";
import SMEBanner from "@routes/Section/layouts/Verticals/SME/components/SMEBanner";
import { VerticalName } from "@util/constant";

type VerticalBannerFactoryProps = {
  /** This is the classname of the component. */
  className?: string;
  /** The vertical name. */
  vertical: VerticalName;
};

/** The vertical banner factory. */
const VerticalBannerFactory = ({
  className,
  vertical,
}: VerticalBannerFactoryProps): React.ReactElement => {
  switch (vertical) {
    case "sme":
      return <SMEBanner className={className} />;

    case "asean":
      return <AseanBanner className={className} />;

    case "ge":
      return <GlobalEnterpriseBanner className={className} />;

    default:
      return <></>;
  }
};

export default VerticalBannerFactory;
